<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'QR(URL)生成' | translate }}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openSelectLanguagesDialog()" style="width: auto;">
      <span>{{'言語選択' | translate }}</span>
    </button>
    <button mat-raised-button class="create_button" color="warn" (click)="createQRCode()"
      [disabled]="!selection.selected.length" style="width: auto;">
      <mat-icon>create</mat-icon>
      <span>{{'QR生成' | translate }}</span>
    </button>
    <button mat-raised-button class="create_button" color="warn" (click)="createURLCode()"
      [disabled]="!selection.selected.length" style="width: auto;">
      <mat-icon>create</mat-icon>
      <span>{{'URL生成' | translate }}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef>{{'No.' | translate }}</th>
      <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="31">
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="qrcodetype">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'生成ページ' | translate }}<br>{{'施設' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.qrcodetype === '番号入力'; else otherType">
          {{ element.qrcodetype_disp }}<br>{{ element.facility_names | multiName:projectLanguages:projectBaseLang }}
        </ng-container>
        <ng-template #otherType>
          {{ element.qrcodetype | translate }}<br>{{ element.facility_names | multiName:projectLanguages:projectBaseLang }}
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="hall_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'建物・カテゴリ' | translate }}<br>{{'フロア・表示グループ' | translate }}</th>
      <td mat-cell *matCellDef="let element"> {{ element.hall_names | multiName:projectLanguages:projectBaseLang }}<br><div *ngIf="element.floor_id != ''">[{{element.floor_id}}]{{ element.floor_names | multiName:projectLanguages:projectBaseLang }}</div> </td>
    </ng-container>

    <ng-container matColumnDef="exhibit_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'展示' | translate }}　　<br>{{'展示詳細' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="element.exhibit_id == ''">&nbsp;</div>
        <div *ngIf="element.exhibit_id != ''">[{{element.exhibit_id}}]{{ element.exhibit_names | multiName:projectLanguages:projectBaseLang }}</div>
        <div *ngIf="element.exhibit_detail_id == ''">&nbsp;</div>
        <div *ngIf="element.exhibit_detail_id != ''">[{{element.exhibit_detail_id}}]{{ element.exhibit_detail_names | multiName:projectLanguages:projectBaseLang }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="quest_set_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'アンケート' | translate }} </th>
      <td mat-cell *matCellDef="let element"> {{ element.quest_set_names |
        multiStringMessage:projectLanguages:projectBaseLang }} </td>
    </ng-container>

    <ng-container matColumnDef="file">
      <th mat-header-cell *matHeaderCellDef>{{'画像' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <img *ngIf="!!element.exhibit_files[0]"
          [src]="(element.exhibit_files[0].file_id | doc:uploadedFilesCollectionName | async)?.download_url"
          height="40px" width="auto">
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>